import React, { useState } from 'react'
import { Form, Input, Popover } from 'antd'
import style from './props.module.sass'
import { ReactComponent as PlusIcon } from "../../../../../../assets/svg/plus_btn.svg";
import I18AutoCompletion from './I18NAutoComplete';
import CustomAutoComplete from './customAutoComplete';

interface IProps {
    json: any,
    options: any[],
    updateOptions: (data: any, key: string) => void,
    canEdit?: boolean
}

export const AddLabelValue = (props: IProps) => {

    const { canEdit = true } = props

    const [label, setLabel] = useState('')
    const [value, setValue] = useState('')

    const labelText: string = props.json.type === 'Table' ? "Header" : "Label"
    const valueText: string = props.json.type === 'Table' ? props.json.data.mode === 'form' ? "Bind Variable" : "Data" : "Value"

    const [labelErr, setLabelErr] = useState(false)
    const [valueErr, setValueErr] = useState(false)
    const [ErrMessage, setErrMessage] = useState("")

    const [labelErrPopup, setLabelErrPopup] = useState(false)
    const [valueErrPopup, setValueErrPopup] = useState(false)

    const options: any[] = props.options;

    const checkIfPresent = (range: any[], key: any, prop: any) => {
        return range.find((option) => option[`${key}`].toLowerCase() === prop.toLowerCase())
    }

    const generateID = () => {
        if (options.length === 0) {
            return 1
        } else {
            //Add 1 to the last option ID and return it
            return options[options.length - 1].id + 1
        }
    }

    const [labelBlur, setLabelBlur] = useState(true);

    const addOption = () => {

        const labelPresent = checkIfPresent(options, 'label', label)
        setLabelErr((!label || labelPresent) ? true : false)

        const valuePresent = checkIfPresent(options, 'value', value)
        setValueErr((!value || valuePresent) ? true : false)

        const id = generateID()
        //Uploader limit exceeds condition
        if ((label && value) && (!labelPresent && !valuePresent) && props.json.type === "Uploader" && props.json.data.uploadLimit <= options.length) {
            setErrMessage("Upload limit exceed!")
            setLabel('');
            setValue('')
            setValueErr(true)
            setLabelErr(true)
            setTimeout(() => {
                setValueErr(false)
                setLabelErr(false)
                setErrMessage("")
            }, 5000)
            // Only add the option if both lable and value is entered and also the entered values are not already present in options
        } else if ((label && value) && (!labelPresent && !valuePresent)) {
            setLabel('');
            setValue('')
            props.updateOptions([...options, { label, value, id }], 'data.options')
        }


    }

    const popOverVisibleChange = (item: string, visible: boolean) => {
        //On mouse out
        if (!visible) {
            (item === 'label') ? setLabelErrPopup(false) : setValueErrPopup(false)
        } else {
            if (item === 'label') {
                (labelErr) ? setLabelErrPopup(true) : setLabelErrPopup(false)
            } else if (item === 'value') {
                (valueErr) ? setValueErrPopup(true) : setValueErrPopup(false)
            }
        }
    }

    return (
        <React.Fragment>
            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: "20px" }} >
                <Form.Item label={labelText} className={'a8-form-item props col-md-5'}>
                    <Popover
                        visible={labelErrPopup}
                        onVisibleChange={(visible) => popOverVisibleChange('label', visible)}
                        placement='topLeft'
                        trigger='hover'
                        content={(<div style={{ color: '#ff7e7a', padding: '0' }}>{label ? `${labelText} exists` : `Empty ${labelText.toLowerCase()}`}</div>)}>
                        <div className={`${labelErr ? style.inputError : style.input} ${style.borderRemove}`}>
                            {
                                labelBlur ?
                                    <div onClick={() => setLabelBlur(false)}>
                                        <I18AutoCompletion dataTestId="data_lable_value"
                                            value={label}
                                            placeholder={`Enter ${labelText}`}
                                            onChange={(val) => {
                                                setLabel(val)
                                                setLabelErr(false)
                                                setLabelErrPopup(false)
                                            }} />
                                    </div>
                                    :
                                    <CustomAutoComplete
                                        dataTestId="data_lable_value"
                                        disabled={!canEdit}
                                        placeholder={`Enter ${labelText}`}
                                        value={label}
                                        onBlur={() => setLabelBlur(true)}
                                        onChange={(val) => {
                                            setLabel(val)
                                            setLabelErr(false)
                                            setLabelErrPopup(false)
                                        }}
                                    />
                            }
                        </div>
                    </Popover>
                </Form.Item>
                <Form.Item label={valueText} className={'a8-form-item props col-md-5'}>
                    <Popover
                        visible={valueErrPopup}
                        onVisibleChange={(visible) => popOverVisibleChange('value', visible)}
                        placement='topLeft'
                        trigger='hover'
                        content={(<div style={{ color: '#ff7e7a', padding: '0' }}>{value ? `${valueText} exists` : `Empty ${valueText.toLowerCase()}`}</div>)}>
                        <Input
                            disabled={!canEdit}
                            placeholder={`Enter ${valueText}`}
                            value={value}
                            onChange={(e) => {
                                setValue(e.target.value)
                                setValueErr(false)
                                setValueErrPopup(false)
                            }}
                            data-test-id="data_lable_value" className={`${valueErr ? style.inputError : style.input} ${style.borderRemove}`} />
                    </Popover>
                </Form.Item>
                <div className={style.iconContainer}>
                    <PlusIcon data-test-id="data_plus_icon" width="24px" height="24px" style={{ cursor: 'pointer' }} onClick={() => canEdit && addOption()} />
                </div>
            </div>
            {ErrMessage && <p style={{ color: "red", marginLeft: "6px" }}>{ErrMessage}</p>}
        </React.Fragment>
    )
}
